import * as React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';

const ActivityLog = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-log',
      // styles
      'flex flex-col rounded-xl bg-white p-5 shadow-dropshadow',
      className
    )}
    {...props}
  />
));
ActivityLog.displayName = 'ActivityLog';

const ActivityLogHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-log-header',
      // styles
      'mb-4 flex flex-wrap items-center justify-between gap-4',
      className
    )}
    {...props}
  />
));
ActivityLogHeader.displayName = 'ActivityLogHeader';

const ActivityLogHeaderTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-activity-log-header-title',
      // styles
      'mb-0 text-base font-bold leading-normal text-primary-dark',
      className
    )}
    {...props}
  />
));
ActivityLogHeaderTitle.displayName = 'ActivityLogHeaderTitle';

const ActivityLogCount = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-activity-log-count',
      // styles
      'mb-0 rounded bg-bright p-2.5 text-sm font-light text-neutral [&>strong]:font-bold [&>strong]:text-neutral-dark',
      className
    )}
    {...props}
  />
));
ActivityLogCount.displayName = 'ActivityLogCount';

const ActivityLogItem = React.forwardRef(({ className, isRead, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-log-item',
      // styles
      'relative mb-4 ml-5 rounded-lg border-l border-transparent p-4 pl-10 transition-all duration-200 ease-in-out',
      'hover:bg-neutral-bright hover:shadow-md',
      'after:absolute after:bottom-[-1em] after:left-0 after:top-0 after:z-0 after:w-px after:-translate-x-px after:border-l after:border-dashed after:border-neutral-lighter after:content-[""] last:after:hidden',
      isRead && 'opacity-40 transition-opacity hover:opacity-100',
      className
    )}
    {...props}
  />
));
ActivityLogItem.displayName = 'ActivityLogItem';

const ActivityLogDateTime = React.forwardRef(({ className, ...props }, ref) => (
  <time
    ref={ref}
    className={cn(
      'c-activity-log-datetime',
      // styles
      'text-[12px] font-light text-neutral',
      className
    )}
    {...props}
  />
));
ActivityLogDateTime.displayName = 'ActivityLogDateTime';

const ActivityLogIcon = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-activity-log-icon',
      // styles
      'absolute left-0 top-0 z-[1] flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full bg-primary-lightest text-primary',
      '[&_svg]:w-4',
      variant === 'danger' && 'bg-danger-lightest text-danger',
      variant === 'trophy' && 'left-auto right-4 top-4 h-4 w-4 rounded-none bg-transparent',
      className
    )}
    {...props}
  />
));
ActivityLogIcon.displayName = 'ActivityLogIcon';

const ActivityLogTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-activity-log-title',
      // styles
      'mb-0 flex flex-wrap items-center gap-2 text-sm font-bold text-primary-dark',
      className
    )}
    {...props}
  />
));
ActivityLogTitle.displayName = 'ActivityLogTitle';

const ActivityLogTag = React.forwardRef(({ className, variant, ...props }, ref) => (
  <span
    ref={ref}
    className={cn(
      'c-activity-log-tag',
      // styles
      'inline-block flex-none truncate bg-[#ccc] px-1 text-sm font-light text-neutral-dark',
      variant === 'course' && 'bg-[#D6FDFF]',
      variant === 'class' && 'bg-[#FFFCBE]',
      variant === 'individual' && 'bg-[#EFEAFF]',
      className
    )}
    {...props}
  />
));
ActivityLogTag.displayName = 'ActivityLogTag';

const ActivityLogDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-activity-log-description',
      // styles
      'mb-0 text-sm font-light text-neutral-dark',
      className
    )}
    {...props}
  />
));
ActivityLogDescription.displayName = 'ActivityLogDescription';

const ActivityLogLink = React.forwardRef(({ className, variant, ...props }, ref) => (
  <Link
    ref={ref}
    className={cn(
      'c-activity-log-link',
      // styles
      'font-bold text-primary underline hover:no-underline',
      variant === 'danger' && 'text-danger',
      className
    )}
    {...props}
  />
));
ActivityLogLink.displayName = 'ActivityLogLink';

export { ActivityLog, ActivityLogHeader, ActivityLogHeaderTitle, ActivityLogCount, ActivityLogItem, ActivityLogDateTime, ActivityLogIcon, ActivityLogTitle, ActivityLogTag, ActivityLogDescription, ActivityLogLink };
